import classNames from 'classnames';
import React from 'react';
import styles from '../styles/blockHeading.module.scss';

export default function BlockHeading(props: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={classNames(styles.heading, props.className)}>
      {props.children}
    </div>
  );
}
